/**
 * Centralised default page-size configuration.
 *
 * Usage with GenericTable:
 *   import { PAGE_SIZES } from "utils/pageSizeConfig";
 *   <GenericTable pageSize={PAGE_SIZES.articleCategory} ... />
 *
 * Usage with useReactTable initialState:
 *   import { PAGE_SIZES } from "utils/pageSizeConfig";
 *   initialState: { pagination: { pageSize: PAGE_SIZES.nzSuburb } }
 *
 * Usage with components that accept defaultPageSize:
 *   <SomeTable defaultPageSize={PAGE_SIZES.proofingDetailSubTable} ... />
 */
export const PAGE_SIZES = {

  // Properties
  propertySearch: 100,
  propertyTenantTab: 100,
  propertyLeaseTab: 10,
  propertyOccRatesTab: 10,
  propertyProposalsTab: 10,
  propertyNabersTab: 10,
  propertyLiftsTab: 10,
  propertySalesTab: 10,
  propertyOwnershipTab: 10,
  propertyQueriesTab: 10,
  propertySaleSheetsTab: 10,
  propertyArticlesTab: 10,

  // Tenants
  tenantSearch: 100, 
  tenantsLeaseReviewsTab: 10,

  // Owners
  ownerSearch: 25,
  ownerDetailPropertiesTab: 25,
  ownerDetailOccupantsTab: 10,
  ownerDetailIndexModalTable: 10,
  ownerDetailCountryOriginModalTable: 10,
  ownerDetailParentCompanyModalTable: 10,

  // Entities
  entitySearch: 25, 
  entityDetailContactsTab: 10,
  entityDetailManagingAgentsTab: 50,
  entityDetailLeasingAgentsTab: 10,
  entityDetailLiftOperatorsTab: 10,
  entityDetailSalesTab: 25,
  entityDetailSaleSheetsTab: 25,

  // Head Offices
  headOfficeSearch: 25,
  headOfficeDetailLeaseTab: 10,

  // Proofing
  adHocProofingPanel: 10,
  otherProofingPanel: 10,
  holdChecks: 25,
  holdChecksSalePropertiesSection: 10,
  holdChecksSaleOwnersSection: 10,
  
  // Queues
  asicSearchResults: 25,
  asicSearchSubTable: 10,
  saleSheets: 25,
  saleSheetFollowUp: 25,
  queriesQueue: 100,
  rpSalesFeed: 100,

  // Lookups
  cityscope: 25,
  schedule: 25,
  articleCategory: 100,
  country: 100,
  cpiRates: 100,
  auSuburb: 25,
  nzSuburb: 25,
  position: 25,
  salutation: 25,
  isCompanyKeywords: 100,
  userList: 25,

  // Merger and Subs
  mergerSubs: 25,

  // Utilities
  walkCopy: 25,
  newsLetter: 10,
  mergerSubsExport: 25, 

  // SLM
  slmAddressSearch: 100,
  slmAddressDetailSold: 10,
  slmAddressDetailLease:10,
  slmLeaseSearch: 100,
  slmSaleSearch: 100,
  slmSaleSearchReviewBuyerSellerList: 25, 
  slmPropertyIntegrationList: 10,
  slmTitleDetailsList: 10,
  slmVolumeFolioList: 10,
  slmEntityDetail: 25,
  slmLookupCategories: 100,
  slmLookupSuburbs: 25,
  slmLookupRCASuppressions: 100,
  slmRCAExport: 10,
  slmAgentAgencySection: 5,
  slmBuyerVendorSection: 5,
  slmLesseLessorSection: 5,

  // Fallback
  default: 25,
};

/**
 * Returns configured page size by key, falling back to PAGE_SIZES.default.
 *
 * @param {string} key
 * @returns {number}
 */
export function getPageSize(key) {
  return PAGE_SIZES[key] ?? PAGE_SIZES.default;
}
